export default __webpack_public_path__ + "static/media/banner1.e9714f40.png";